import React from 'react';
import { NavBarGroupType } from './types';
import NavbarItem from './NavbarItem';

type IProps = {
  group: NavBarGroupType;
  expanded: boolean;
  shouldDisplayDivider: boolean;
  shouldShowGroupName?: boolean;
};

function NavbarGrouping({
  group,
  expanded,
  shouldDisplayDivider,
  shouldShowGroupName = true,
}: IProps) {
  const [groupName, items] = Object.entries(group)[0];
  const displayDivider = !expanded && shouldDisplayDivider;
  if (!items || items.length === 0 || !items.some((item) => item.displayCondition)) {
    return null;
  }

  return (
    <div className="navbar-v2-group-wrapper">
      {shouldShowGroupName && (
        <div
          className={`navbar-v2-group-title ${
            expanded ? 'navbar-v2-group-title-expanded' : 'navbar-v2-group-title-collapsed'
          }`}
        >
          {groupName}
        </div>
      )}
      {displayDivider && <div className={`navbar-icon-divider`}></div>}
      <div className="navbar-v2-group-items">
        {items.map((item, index) => {
          if (!item.displayCondition) {
            return null;
          }

          const icon = item.isActive ? item.activeIcon : item.icon;

          return (
            <NavbarItem
              key={`${groupName}-${index}`}
              expanded={expanded}
              icon={icon}
              title={expanded ? item.displayName : item.title}
              permission={item.permission}
              onClick={item.onClick}
              isActive={item.isActive}
              isLocked={item.isLocked}
            />
          );
        })}
      </div>
    </div>
  );
}

export default NavbarGrouping;
